import {Tooltips}    from './tooltips';
import {MatchHeight} from './match-height';
import {Tab}         from './tab';
import {Hamburger}   from './hamburger';
import Vue from 'vue';
import VueArtists from './components/VueArtists';
import VueLazyload from 'vue-lazyload';
import {Gallery} from './gallery-grid';
import Playlist from './playlist';

Vue.use(VueLazyload);

export class App {

	constructor() {
		this.matchHeight = {selector: ''};
		this.tooltips = {selector: '', id: ''};
		this.tab = {selector: 'tabs'};
	}

	initVue() {
		this.vue = new Vue({
			el:         '#app',

			components: {
				'artist' : VueArtists,
			},

			data: {
				test: "test",
			},
		})
	}

	// Same height initialization
	initSameHeight() {
		const matchHeight = new MatchHeight(this.matchHeight.selector);
		matchHeight.init();
	}

	// Tooltips initialization
	initTooltips() {
		const tooltips = new Tooltips(this.tooltips.selector, this.tooltips.id);
		tooltips.init();
	}

	initTab() {
		let tabs = document.getElementsByClassName(this.tab.selector);
		if (tabs.length) {
			for (let i = 0; i < tabs.length; i++) {
				const tab = new Tab(tabs[i]);
				tab.init();
			}
		}
	}

	initHamburger() {
		let header = document.getElementById('myHeader');

		if(header) {
			const hamburger = new Hamburger(header);
		}
	}

	static initIsotopeGalelry() {
		let galleryGrid = document.querySelector('#gallery');

		if(galleryGrid) {
			const galleryIsotope = new Gallery(galleryGrid);
			galleryIsotope.init();
		}
	}

	initPlaylist() {
		const getAllWordpressPlaylist = document.querySelector('.wp-playlist');

		if (getAllWordpressPlaylist) {
			new Playlist(getAllWordpressPlaylist);
		}
	}

	init() {
		this.initVue();
		this.initHamburger();
		this.initSameHeight();
		this.initTooltips();
		this.initTab();
		this.initPlaylist();
		App.initIsotopeGalelry();
	}
}
